export default __webpack_public_path__ + "static/media/one-stage.daf1f88d.png";